import React, { useState, useEffect } from 'react';
import axios from 'axios';
import getAPI from "../../service/getAPI";
import { Modal } from 'react-bootstrap';
import AddNew from './Customer-addnew';
import CustomerModal from './CustomerModal';
function Customer() {
    const { master } = getAPI();
    const [showViewModal, setShowViewModal] = useState(false);
    const [showFormModal, setShowFormModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [viewData, setViewData] = useState(null);
    const [user, setUser] = useState(null);
    const [selectedStoreId, setSelectedStoreId] = useState("");
    const [storeList, setStoreList] = useState([]);
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(() => {
        // Load from localStorage if available, otherwise default to 10
        return Number(localStorage.getItem("pageSize")) || 10;
    });
    const [total, setTotal] = useState(0);

    const fetchStoreList = async (adminStoreId = null, isStore = false, storeId = null) => {
        try {
            const requestData = { pageIndex: 1, pageSize: 100 };
            const res = await axios.post(master.storelist_all, requestData);
            if (res.data.flag === 1) {
                const list = res.data.data.filter(
                    (store) => store.user_type === "store" || store.user_type === "admin"
                );
                setStoreList(list);

                if (list.length > 0) {
                    if (isStore && storeId) {
                        setSelectedStoreId(storeId);
                    } else {
                        const adminStore = list.find((s) => s.store_id === adminStoreId);
                        const defaultStoreId = adminStore ? adminStore.store_id : list[0].store_id;
                        setSelectedStoreId(defaultStoreId);
                    }
                }
            }
        } catch (err) {
            console.error("Error fetching stores:", err);
        }
    };

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        let adminStoreId = null;
        let isStore = false;
        let storeId = null;

        if (storedUser) {
            const parsed = JSON.parse(storedUser);
            setUser(parsed);
            isStore = parsed.type === "store" || parsed.user_type === "store";
            storeId = parsed.id || parsed.store_id;

            if (!isStore) {
                adminStoreId = storeId;
            }
        }
        fetchStoreList(adminStoreId, isStore, storeId);
    }, []);

    useEffect(() => {
        if (user && selectedStoreId) {
            loadData();
        }
        // Save to localStorage whenever limit changes
        localStorage.setItem("pageSize", limit);
    }, [user, page, limit, selectedStoreId]);

    const loadData = async (pageNo = page) => {
        try {
            const requestData = {
                page: pageNo,
                limit,
                search: { value: "" }
            };

            if (selectedStoreId && selectedStoreId !== "ALL") {
                requestData.store_id = selectedStoreId;
            } else if (selectedStoreId === "ALL") {
                requestData.store_id = 0; // Prevent interceptor from injecting default
            }

            const res = await axios.post(master.customerListPagination, requestData);

            if (res.data.flag === 1) {
                setList(res.data.data.result);
                setTotal(res.data.data.count); // Assuming the API sends total count
            } else {
                setList([]);
                setTotal(0);
            }
        } catch (err) {
            console.error("Error loading employee list:", err);
        }
    };

    const totalPages = Math.ceil(total / limit);

    const handleDelete = async (delivery_boy_id) => {
        if (window.confirm("Are you sure you want to delete this delivery boy?")) {
            try {
                const res = await axios.post(`${master.deliveryBoyDelete}`, {
                    delivery_boy_id: delivery_boy_id
                });

                if (res.data.flag === 1) {
                    alert("Delivery boy deleted successfully.");
                    loadData(); // Reload list after deletion
                } else {
                    alert(res.data.message || "Failed to delete the delivery boy.");
                }
            } catch (err) {
                console.error("Error while deleting delivery boy:", err);
                alert("Something went wrong while deleting the delivery boy.");
            }
        }
    };

    const handleModalClose = () => {
        setShowViewModal(false);
        setShowFormModal(false);
        setEditData(null);
        setViewData(null);
        loadData();
    };

    const handleEditClick = (employee) => {
        setEditData(employee);
        setShowFormModal(true);
    };

    const handleViewClick = (employee) => {
        setViewData(employee);
        setShowViewModal(true);
    };

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Manage Customers</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a>Masters</a></li>
                        <li className="breadcrumb-item active">Customers</li>
                    </ol>
                </nav>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-header d-flex flex-wrap align-items-center gap-3">
                            {(user?.type === "admin" || user?.user_type === "admin") && (
                                <div>
                                    <label htmlFor="storeSelect" className="form-label fw-bold text-primary me-2">
                                        Select Store
                                    </label>
                                    <select
                                        id="storeSelect"
                                        className="form-select shadow-sm border-primary d-inline-block w-auto"
                                        value={selectedStoreId}
                                        onChange={(e) => {
                                            setSelectedStoreId(e.target.value);
                                            setPage(1);
                                        }}
                                    >
                                        <option value="ALL">All Stores</option>
                                        {storeList.map((store) => (
                                            <option key={store.store_id} value={store.store_id}>
                                                {store.store_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div style={{ flexGrow: 1 }}></div>
                            <div style={{ float: "right" }}>
                                {/* <button
                                    style={{ background: 'none', border: 'none', color: 'green', cursor: 'pointer', fontSize: '14px' }}
                                    onClick={() => setShowFormModal(true)}
                                >
                                    Add New
                                </button> */}
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr className="table-secondary">
                                            <th>#</th>
                                            {/* <th>Profile</th> */}
                                            <th>Name</th>
                                            {selectedStoreId === "ALL" && <th>Store</th>}
                                            <th>Mobile No.</th>
                                            <th>Active</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.length > 0 ? (
                                            list.map((customer, index) => (
                                                <tr key={index}>
                                                    <td>{customer.customer_id}</td>
                                                    {/* <td>
                                                        <img
                                                            src={customer.profile_url || "/assets/img/avatar.jpg"}
                                                            alt="Profile"
                                                            style={{ width: "30px", height: "30px", objectFit: "cover", borderRadius: "5px" }}
                                                        />
                                                    </td> */}
                                                    <td>{customer.customer_name}</td>
                                                    {selectedStoreId === "ALL" && (
                                                        <td>
                                                            <span className="fw-bold text-secondary">
                                                                {customer.store_name || storeList.find(s => s.store_id === customer.store_id)?.store_name || "N/A"}
                                                            </span>
                                                        </td>
                                                    )}
                                                    <td>{customer.mobile_no}</td>
                                                    <td>
                                                        <span className={`badge ${customer.is_active === 1 ? 'bg-success' : 'bg-warning'}`}>
                                                            {customer.is_active === 1 ? 'Active' : 'Inactive'}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="d-inline-flex align-items-center flex-nowrap">
                                                            <span className="fontPadding actionView cursorP me-2" onClick={() => handleViewClick(customer)}>
                                                                <i className="bi bi-eye"></i>
                                                            </span>
                                                            <span className="fontPadding actionEdit cursorP me-2" onClick={() => handleEditClick(customer)}>
                                                                <i className="bi bi-pencil-square"></i>
                                                            </span>
                                                            <span className="fontPadding actionDelete cursorP" onClick={() => handleDelete(customer.delivery_boy_id)}>
                                                                <i className="bi bi-trash"></i>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">No data found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            {/* Pagination Controls */}
                            <div className="card-footer d-flex justify-content-between align-items-center flex-wrap">
                                {/* Showing X to Y of Z */}
                                <div className="me-auto small text-muted">
                                    {total === 0 ? (
                                        <>No records to display</>
                                    ) : total <= limit ? (
                                        <>Showing all <strong>{total}</strong> records</>
                                    ) : (
                                        <>
                                            Showing <strong>{(page - 1) * limit + 1}</strong> – <strong>{Math.min(page * limit, total)}</strong> of <strong>{total}</strong> records
                                        </>
                                    )}
                                </div>

                                {/* Page Size Selection */}
                                <div className="d-flex align-items-center me-3">
                                    <label htmlFor="pageSize" className="me-2 mb-0">Show:</label>
                                    <select
                                        id="pageSize"
                                        value={limit}
                                        onChange={(e) => {
                                            setLimit(Number(e.target.value));
                                            setPage(1);
                                        }}
                                        className="form-select d-inline-block"
                                        style={{ width: "80px" }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                    <span className="ms-2">entries</span>
                                </div>

                                {/* Pagination Controls */}
                                {totalPages > 1 && (
                                    <>
                                        <button
                                            className="btn btn-outline-primary me-2"
                                            onClick={() => setPage(page - 1)}
                                            disabled={page === 1}
                                        >
                                            &laquo; Prev
                                        </button>

                                        <select
                                            className="form-select w-auto me-2"
                                            value={page}
                                            onChange={(e) => setPage(Number(e.target.value))}
                                        >
                                            {Array.from({ length: totalPages }, (_, i) => (
                                                <option key={i} value={i + 1}>
                                                    Page {i + 1}
                                                </option>
                                            ))}
                                        </select>

                                        <button
                                            className="btn btn-outline-primary"
                                            onClick={() => setPage(page + 1)}
                                            disabled={page === totalPages}
                                        >
                                            Next &raquo;
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* View Modal */}
            <CustomerModal
                show={showViewModal}
                onClose={handleModalClose}
                viewData={viewData}
            />

            {/* Add/Edit Modal */}
            <Modal show={showFormModal} onHide={handleModalClose} size="xl">
                <AddNew onClose={handleModalClose} editData={editData} storeId={user?.store_id} />
            </Modal>
        </main>
    );
}

export default Customer;
